//https://mariestarck.com/add-google-analytics-to-your-next-js-application-in-5-easy-steps/

export const event = ({ action, params }) => {
  window.gtag("event", action, params);
};
